import React from 'react';

import cn from 'classnames';

import { useFloatingPosition } from '@shared/hooks';

import cls from './MenuList.module.css';
import { TMenuItem } from './model/types';

interface IMenuListProps {
    menuData: TMenuItem[];
    anchorRef: React.RefObject<HTMLElement>;
    onClose: () => void;
    listContainerClassName?: string;
    isOpen: boolean;
}

export const MenuList = ({
    menuData,
    anchorRef,
    onClose,
    listContainerClassName,
    isOpen,
}: IMenuListProps) => {
    const { refs, floatingStyles, getFloatingProps } = useFloatingPosition({
        anchorRef,
        onClose,
        isOpen,
        crossAxis: 12,
        mainAxis: 6,
    });

    if (!isOpen) return null;

    return (
        <ul
            ref={refs.setFloating}
            style={floatingStyles}
            {...getFloatingProps()}
            className={cn(cls.MenuList, listContainerClassName)}
        >
            {menuData.map((item) => (
                <li
                    className={cn(cls.MenuItem, item.itemClassName)}
                    key={item.id}
                    onClick={() => {
                        item?.onClick();
                        onClose();
                    }}
                >
                    {item.IconLeft && item.IconLeft}
                    <span className={cls.name}>{item.name}</span>
                    {item.IconRight && item.IconRight}
                </li>
            ))}
        </ul>
    );
};
